import React from 'react';
import ReactDOM from 'react-dom';
import { CookiesProvider } from 'react-cookie';
import AppWithRouterAccess from './router/AppWithRouterAccess';
import { ConfigContextProvider } from './security/ConfigContext';

import './index.css';
import { SocketContextProvider } from './context/SocketContext';

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <ConfigContextProvider>
        <SocketContextProvider>
          <AppWithRouterAccess />
        </SocketContextProvider>
      </ConfigContextProvider>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
